var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import { CardContent } from 'material-ui';
import { doorStatusChange, stopRequestChange } from './actions';
import { CustomCardHeader } from '../CustomCardHeader';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import TestModeDependentContainer from '../../containers/TestModeDependentContainer';
var DoorStatusComponent = /** @class */ (function (_super) {
    __extends(DoorStatusComponent, _super);
    function DoorStatusComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onStopRequestChange = function (event) {
            _this.props.stopRequestChange(!_this.props.stopRequest);
        };
        _this.onDoorStatusChange = function (event) {
            _this.props.doorStatusChange(!_this.props.doorStatus);
        };
        return _this;
    }
    DoorStatusComponent.prototype.render = function () {
        var _a = this.props, doorStatus = _a.doorStatus, stopRequest = _a.stopRequest;
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomCardHeader, null, "Vehicle"),
            React.createElement(CardContent, { style: { padding: '12px 16px' } },
                React.createElement(Grid, { container: true, direction: "row", justify: "space-around", alignItems: "center" },
                    React.createElement(TestModeDependentContainer, { referenceMode: "automated" },
                        React.createElement(Grid, { item: true, style: { textAlign: 'center' }, xs: 6 },
                            React.createElement(Button, { variant: "raised", color: stopRequest ? 'secondary' : 'primary', onClick: this.onStopRequestChange }, stopRequest ? 'Cancel request' : 'Request stop'))),
                    React.createElement(Grid, { item: true, style: { textAlign: 'center' }, xs: 6 },
                        React.createElement(Button, { variant: "raised", color: doorStatus ? 'secondary' : 'primary', onClick: this.onDoorStatusChange }, doorStatus ? 'Close doors' : 'Open doors'))))));
    };
    return DoorStatusComponent;
}(React.PureComponent));
export default connect(function (state) { return ({ doorStatus: state.doorStatus, stopRequest: state.stopRequest }); }, { doorStatusChange: doorStatusChange, stopRequestChange: stopRequestChange })(DoorStatusComponent);



//////////////////
// WEBPACK FOOTER
// ./src/components/DoorStatus/index.tsx
// module id = 1772
// module chunks = 0